module.exports = __webpack_public_path__ + "img/8-Guy_W_The_Cap RIGHT.a6ee2e2.png";